<template>
  <div class="base-report report-audit">
    <div class="filter">
      <el-form inline>
        <el-select v-model="searchForm.classification" size="mini" >
          <el-option
            v-for="item in classifications"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-date-picker
          v-model="searchForm.from_date"
          type="date"
          size="mini"
          placeholder="開始日"
          value-format="yyyy-MM-dd"
          :clearable="false">
        </el-date-picker>
        <el-date-picker
          v-model="searchForm.to_date"
          type="date"
          size="mini"
          placeholder="終了日"
          value-format="yyyy-MM-dd"
          :clearable="false">
        </el-date-picker>
        <el-button size="mini" type="primary" @click="fetchData" :disabled="isLoading">表示</el-button>
        <div style="float: right; padding-right: 20px;">
          <el-button v-show="$store.getters.isPC && screenData.length>0" size="mini" type="success" icon="el-icon-download" @click="exportCSV">ダウンロード</el-button>
        </div>
      </el-form>
    </div>
    <div class="table_data" v-loading="isLoading">
      <template v-if="screenData.length>0">
        <el-table
          :data="screenData"
          border
          stripe
          height="100%">
          <template v-for="header in tableSetting">
            <template v-if="header.prop === 'date'">
              <el-table-column
                :key=header.prop
                :label=header.label
                :prop=header.prop
                :fixed=header.fixed
                :align=header.align
                :sortable=header.sortable
                :min-width=header.width>
                <template slot-scope="scope">
                  <div class="date">
                    {{ scope.row.date|date }}
                    <span class="w" :class="weekdayClass(scope.row)">{{ printWeekday(scope.row) }}</span>
                  </div>
                </template>
              </el-table-column>
            </template>
            <template v-else-if="!Array.isArray(header)">
              <el-table-column
                :key=header.prop
                :label=header.label
                :prop=header.prop
                :formatter="formatter"
                :fixed=header.fixed
                :align=header.align
                :sortable=header.sortable
                :min-width=header.width>
              </el-table-column>
            </template>
          </template>
        </el-table>
      </template>
      <div v-else v-show="noData">
        データがありません。<br>
        条件を変えて再度「表示」ボタンを押してください。
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import moment from 'moment'
import _ from 'lodash'
import addFigure from '@/misc/addFigure.js'
import downloadCSV from '@/misc/downloadCSV.js'

export default {
  name: 'ReportAudit',
  data () {
    const classificationType = {
      cancelItem: 0,
      cancelOrder: 1,
      refund: 2,
      reaccount: 3,
    }
    return {
      rounding: null,
      isLoading: false,
      noData: false,
      classifications: [
        {value: classificationType.cancelItem, label: '商品キャンセル'},
        {value: classificationType.cancelOrder, label: 'オーダーキャンセル'},
        {value: classificationType.refund, label: '払戻し'},
        {value: classificationType.reaccount, label: '再会計'},
      ],
      staticSetting: [
        {label: '年月日', prop: 'date', align: 'center', fixed: true, sortable: true, width: '130px'},
        {label: '時間', prop: 'hhmm', align: 'center', sortable: true, width: '80px'},
        {label: 'レシート番号', prop: 'receiptNumber', sortable: true, align: 'center', width: '150px'},
        {label: 'オーダー番号', prop: 'orderId', align: 'center', sortable: true, width: '80px'},
        {label: '担当者名', prop: 'staffName', align: 'left', sortable: true, width: '130px'},
        {label: '商品数', prop: 'itemCount', align: 'right', sortable: true, width: '80px'},
        {label: '金額', prop: 'sales', align: 'right', sortable: true, width: '130px'},
      ],
      tableSetting: [],
      searchForm: {
        classification: classificationType.cancelItem,
        from_date: null,
        to_date: null,
      },
      currentClassification: classificationType.cancelItem,
      orgData: [],
      orgTotalData: {},
      totalData: [],
      csv_filename: '監査.csv',
    }
  },
  computed: {
    ...mapGetters('account', [
      'isGroupMode',
    ]),
    ...mapGetters('holiday', ['holidays']),
    screenData: function () {
      return this.orgData
    },
    ...mapGetters('report', ['roundingFunction']),
  },
  filters: {
    date (value) {
      return moment(value).format('YYYY/MM/DD')
    },
  },
  methods: {
    ...mapActions('holiday', ['getHolidays']),
    fetchData () {
      this.isLoading = true
      this.noData = false
      this.orgTotalData = {}
      this.orgData = []
      this.tableSetting = _.cloneDeep(this.staticSetting)
      this.currentClassification = this.searchForm.classification
      this.$request.reports.audits(this.searchForm.from_date, this.searchForm.to_date, this.searchForm.classification).then(res => {
        this.items = res.body

        for (let record of this.items.records) {
          this.orgData.push(record)
        }

        // update table setting
        if (this.isGroupMode) {
          let shopCol = {label: '店舗名', prop: 'shopName', fixed: true, align: 'right', sortable: true, width: '150px'}
          this.tableSetting.unshift(shopCol)
        }
      }, err => {
        console.log(err)
      }).finally(() => {
        this.isLoading = false
        this.noData = !this.screenData.length
      })
    },
    onMessageCallBack (event) {
      let tmp = JSON.parse(event.data)
      if (tmp.data) {
        this.orgData.push(tmp.data)
      }
    },
    exportCSV () {
      let header = []
      let keyList = []
      for (let tableHeader of this.tableSetting) {
        if (Array.isArray(tableHeader)) {
          let preHeader = header.pop()
          // check padding
          if (!preHeader) {
            continue
          }
          for (let subHeader of tableHeader) {
            if (subHeader.prop) {
              keyList.push(subHeader.prop)
            }
            header.push(`${preHeader}-${subHeader.label}`)
          }
        } else {
          if (tableHeader.prop) {
            keyList.push(tableHeader.prop)
          }
          header.push(tableHeader.label)
        }
      }
      let data = []
      for (let record of this.screenData) {
        let tmp = []
        for (let key of keyList) {
          tmp.push(this.formatData(key, record[key]))
        }
        data.push(tmp)
      }

      downloadCSV(this.csv_filename, header, data, this.totalData)
    },
    date (value) {
      let result = '-'
      let date = moment(value, 'YYYY-MM-DD').format('YYYY/MM/DD')
      let day = moment(value, 'YYYY-MM-DD').locale('ja').format('ddd')
      result = date + '(' + day + ')'

      return result
    },
    formatter (row, column) {
      let key = column.property
      return this.formatData(key, row[key])
    },
    formatData (key, value) {
      let result = !isNaN(value) ? value : 0

      switch (key) {
        case 'date':
          return this.date(value)
        case 'shopName':
          return value
        case 'hhmm':
          return value
        case 'receiptNumber':
          return value
        case 'orderId':
          return value
        case 'staffName':
          return value
        case 'itemCount':
          return value
        case 'sales':
          return addFigure(this.rounding(value))
        default:
          break
      }
      return result
    },
    isHoliday (date, before = false) {
      const k = before ? moment(date).add(1, 'days').format('YYYY-MM-DD') : moment(date).format('YYYY-MM-DD')
      if (this.holidays[k]) {
        return true
      }
      return false
    },
    printWeekday (item) {
      if (this.isHoliday(item.date)) {
        return '祝'
      }
      return moment(item.date).locale('ja').format('ddd')
    },
    weekdayClass (item) {
      if (this.isHoliday(item.date)) {
        return 'hol'
      }
      let ret = moment(item.date).locale('en').format('ddd').toLowerCase()
      if (ret !== 'sun' && this.isHoliday(item.date, true)) {
        return 'bho'
      }
      return ret
    },
  },
  created () {
    this.rounding = this.roundingFunction
  },
  mounted () {
    this.getHolidays()
    this.searchForm.from_date = moment().date(1).format('YYYY-MM-DD')
    this.searchForm.to_date = moment().format('YYYY-MM-DD')
//    this.fetchData()
  },
}
</script>

<style lang="sass">
@import "static/sass/report/common.sass"
</style>

<style scoped>
div.date {
  text-align: center;
  height: 40px;
  line-height: 40px;
}

div.date span.w {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-left: 4px;
  background-color: #ABC;
  border-radius: 50%;
  line-height: 16px;
  font-size: 0.7em;
  text-align: center;
  color: #FFF;
  vertical-align: 2px;
}

div.date span.w.sat,
div.date span.w.bho {
  background-color: #3CD;
}

div.date span.w.sun,
div.date span.w.hol {
  background-color: #E34;
}
</style>



// WEBPACK FOOTER //
// src/components/Report/ReportAudit.vue